import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { Account } from '../api/types';
import config from '../config';

async function getAccount(axios: AxiosInstance, id: number | undefined): Promise<Account> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v2/account/` + id);
  return data.data;
}

export default function useAccountV2Query(id: number | undefined) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getAccount(axios, id),
    enabled: !!id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id: number | undefined) {
  return ['Account', id] as const satisfies QueryKey;
}
useAccountV2Query.getKey = getKey;
